export const getCreateModalId = (id?: string) => `${id}-create-vat-rate-modal`
